// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__3VcAm","footer":"ChangeClinic_footer__2aegA"};